import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";
var token = localStorage.getItem("x-access-token");

export const allGrossisteType = createAsyncThunk("grossiste/allGrossisteType", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "grossiste/allGrossisteType", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const grossiste = await response.json();
  return grossiste;
});
export const saveImageGrossiste = createAsyncThunk("grossiste/saveImageGrossiste", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "grossiste/saveImageGrossiste", {
    method: 'POST',
    headers: {
      'Accept': 'application/*',
      'x-access-token': token,
    },
    body: action
  });
  const grossiste = await response.json();
  return grossiste;
});
export const fetchGrossiste = createAsyncThunk("grossiste/fetchGrossiste", async () => {
  const response = await fetch(Configuration.BACK_BASEURL + "grossiste/allGrossiste", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },

  });
  const grossiste = await response.json();
  return grossiste;
});

export const fetchGrossisteSite = createAsyncThunk("grossiste/fetchGrossisteSite", async () => {
  const response = await fetch(Configuration.BACK_BASEURL + "grossiste/allGrossisteSite", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },

  });
  const grossiste = await response.json();
  return grossiste;
});
export const fetchGrossisteClient = createAsyncThunk("grossiste/fetchGrossisteClient", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "grossiste/fetchGrossisteCommande", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const grossiste = await response.json();
  return grossiste;
});

export const grossisteAdded = createAsyncThunk("grossiste/addGrossiste", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "grossiste/addGrossiste", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)

  });
  const grossiste = await response.json();
  return grossiste;
});
export const updateGrossiste = createAsyncThunk("grossiste/updateGrossiste", async (data) => {
  const response = await fetch(Configuration.BACK_BASEURL + "grossiste/updateGrossiste", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(data),
  });

  const grossiste = await response.json();
  return grossiste;
});
export const grossisteGetById = createAsyncThunk("grossiste/grossisteGetById", async (id1) => {
  const id = id1;
  const response = await fetch(Configuration.BACK_BASEURL + "grossiste/getGrossiste", {
    method: 'POST',
    headers: {
      'id': id,
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },

  });
  const grossiste = await response.json();
  return grossiste;
});

export const getGrossisteSite = createAsyncThunk("grossiste/getGrossisteSite", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "grossiste/getGrossisteSite", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token':token
    },
    body: JSON.stringify(action)

  });
  const grossiste = await response.json();
  return grossiste;
});


const grossisteReduce = createSlice({
  name: "grossiste",
  initialState: {
    entities: [],
    loading: false,
  },
  reducers: {
    grossisteDeleted(state, action) {
      const { id } = action.payload;
      return new Promise((resolve, reject) => {
        fetch(Configuration.BACK_BASEURL + "grossiste/deleteGrossiste/" + id, {
          method: 'DELETE',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': token
          },
        })
        .then(response => {
          console.log('Grossiste supprimée avec succès');
          resolve(); // Résoudre la promesse si la suppression réussit
        })
        .catch(error => {
          console.error('Erreur lors de la suppression de l\'grossiste:', error);
          reject(error); // Rejeter la promesse en cas d'erreur
        });
      });
    },
    

  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGrossiste.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchGrossiste.fulfilled, (state, action) => {
        state.loading = false;
        state.entities = [...state.entities, ...action.payload];
      })
      .addCase(fetchGrossiste.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(grossisteGetById.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(grossisteGetById.fulfilled, (state, action) => {
        state.loading = false;
        state.entities = [...state.entities, action.payload];
      })
      .addCase(grossisteGetById.rejected, (state, action) => {
        state.loading = false;
      });
  },

});

export const { grossisteDeleted } = grossisteReduce.actions;

export default grossisteReduce.reducer;
